import * as React from 'react';

export default function IconPhone({ className }: { className?: string }) {
  return (
    <svg fill="none" viewBox="0 0 24 24" className={className}>
      <rect
        x="5"
        y="2"
        width="14"
        height="20"
        rx="1"
        stroke="#000"
        strokeOpacity=".65"
        strokeWidth="1.2"
        strokeLinecap="round"
      />
      <path
        clipRule="evenodd"
        d="M12 20a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z"
        stroke="#000"
        strokeOpacity=".65"
      />
      <path
        d="M19 15.75H5v.5h14v-.5Z"
        stroke="#000"
        strokeOpacity=".65"
        strokeWidth=".5"
      />
    </svg>
  );
}
